import {
  ARCHIVE_PAYMENT_DEADLINE,
  REACTIVATE_PAYMENT_DEADLINE,
} from "./../../../../queries/neoFact/catalog";
import { useEffect } from "react";
import { useLazyQuery, useMutation } from "@apollo/client";
import { clientNeoFact } from "@neonumy/api-clients";
import { onErrorGraphql } from "utils/onErrorGraphql";
import {
  CREATE_CATEGORY,
  DELETE_CATEGORY,
  GET_CATEGORY,
  LIST_CATEGORY,
  UPDATE_CATEGORY,
} from "queries/neoFact/catalog";

export default function useCategoryApi(id?: ID) {
  const [
    listCategories,
    { refetch, loading, data: listCategoriesData, error: listCategoriesError },
  ] = useLazyQuery<ListCategoriesResponse, ListCategoriesVars>(LIST_CATEGORY, {
    client: clientNeoFact,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (listCategoriesError) onErrorGraphql(listCategoriesError);
  }, [listCategoriesError]);

  const dataSource =
    listCategoriesData?.listCategories?.results?.map(item => ({
      ...item,
      key: item.id,
    })) ?? [];

  const totalCount = listCategoriesData?.listCategories?.totalCount ?? 0;

  const [
    getCategory,
    { refetch: refetchGetCategory, data: getCategoryData, error: getCategoryError },
  ] = useLazyQuery<GetCategoryResponse, GetVarTypeID>(GET_CATEGORY, {
    client: clientNeoFact,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (getCategoryError) onErrorGraphql(getCategoryError);
  }, [getCategoryError]);

  const formData = getCategoryData?.getCategory;

  const [
    createUpdateCategory,
    { loading: createUpdateCategoryLoading, error: createUpdateCategoryError },
  ] = useMutation<CreateUpdateCategoryMutationResponse, CreateCategoryVars | UpdateCategoryVars>(
    id ? UPDATE_CATEGORY : CREATE_CATEGORY,
    {
      client: clientNeoFact,
      fetchPolicy: "no-cache",
    },
  );

  useEffect(() => {
    if (createUpdateCategoryError) onErrorGraphql(createUpdateCategoryError);
  }, [createUpdateCategoryError]);

  const [deleteCategory, { loading: deleteCategoryLoading, error: deleteCategoryError }] =
    useMutation<DeleteCategoryResponse, GetVarTypeID>(DELETE_CATEGORY, {
      client: clientNeoFact,
      fetchPolicy: "no-cache",
    });

  useEffect(() => {
    if (deleteCategoryError) onErrorGraphql(deleteCategoryError);
  }, [deleteCategoryError]);

  const [
    archiveCompanyPaymentDeadline,
    { loading: archiveCompanyPaymentDeadlineLoading, error: archiveCompanyPaymentDeadlineError },
  ] = useMutation<ArchivePaymentDeadlineResponse, GetVarTypeID>(ARCHIVE_PAYMENT_DEADLINE, {
    client: clientNeoFact,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (archiveCompanyPaymentDeadlineError) onErrorGraphql(archiveCompanyPaymentDeadlineError);
  }, [archiveCompanyPaymentDeadlineError]);

  const [
    reactivateCompanyPaymentDeadline,
    {
      loading: reactivateCompanyPaymentDeadlineLoading,
      error: reactivateCompanyPaymentDeadlineError,
    },
  ] = useMutation<ReactivatePaymentDeadlineResponse, GetVarTypeID>(REACTIVATE_PAYMENT_DEADLINE, {
    client: clientNeoFact,
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (reactivateCompanyPaymentDeadlineError)
      onErrorGraphql(reactivateCompanyPaymentDeadlineError);
  }, [reactivateCompanyPaymentDeadlineError]);

  return {
    refetch,
    loading,
    formData,
    dataSource,
    totalCount,
    getCategory,
    deleteCategory,
    listCategories,
    refetchGetCategory,
    createUpdateCategory,
    deleteCategoryLoading,
    createUpdateCategoryLoading,
    archiveCompanyPaymentDeadline,
    reactivateCompanyPaymentDeadline,
    archiveCompanyPaymentDeadlineLoading,
    reactivateCompanyPaymentDeadlineLoading,
  };
}
